import React from "react";
import JavaScriptLogo from "../assets/javascript.svg";
import ReactLogo from "../assets/react.svg";
import ReduxLogo from "../assets/redux.svg";
import TypeScriptLogo from "../assets/typescript.svg";
import PreactLogo from "../assets/preact.svg";
import NodeJSLogo from "../assets/nodejs.svg";
import MongoDBLogo from "../assets/mongodb.svg";
import NPMLogo from "../assets/npm.svg";
import GitLogo from "../assets/git.svg";
import GitHubLogo from "../assets/github.svg";
import VSCodeLogo from "../assets/visual-studio-code.svg";
import NotionLogo from "../assets/notion.svg";

const Skills = () => {
  return (
    <div className="container container-fluid p-5 mt-auto">
      <h1 className="display-4 mb-5 text-center">Languages and Tools</h1>
      <img
        align="left"
        className="ml-4"
        alt="JavaScript"
        title="JavaScript"
        src={JavaScriptLogo}
        width="60"
      />
      <img
        align="left"
        className="ml-4"
        alt="React"
        title="React"
        src={ReactLogo}
        width="60"
      />
      <img
        align="left"
        className="ml-4"
        alt="Redux"
        title="Redux"
        src={ReduxLogo}
        width="60"
      />
      <img
        align="left"
        className="ml-4"
        alt="TypeScript"
        title="TypeScript"
        src={TypeScriptLogo}
        width="60"
      />
      <img
        align="left"
        className="ml-4"
        alt="Preact"
        title="Preact"
        src={PreactLogo}
        width="60"
      />
      <img
        align="left"
        className="ml-4"
        alt="Node.js"
        title="Node.js"
        src={NodeJSLogo}
        width="60"
      />
      <img
        align="left"
        className="ml-4"
        alt="MongoDB"
        title="MongoDB"
        src={MongoDBLogo}
        width="60"
      />
      <img
        align="left"
        className="ml-4"
        alt="npm"
        title="npm"
        src={NPMLogo}
        width="60"
      />
      <img
        align="left"
        className="ml-4"
        alt="Git"
        title="Git"
        src={GitLogo}
        width="60"
      />
      <img
        align="left"
        className="ml-4"
        alt="GitHub"
        title="GitHub"
        src={GitHubLogo}
        width="60"
      />
      <img
        align="left"
        className="ml-4"
        alt="Visual Studio Code"
        title="Visual Studio Code"
        src={VSCodeLogo}
        width="60"
      />
      <img
        align="left"
        className="ml-4"
        alt="Notion"
        title="Notion"
        src={NotionLogo}
        width="60"
      />
    </div>
  );
};

export default Skills;
